import type { StringGUID } from "@pdfking/tfunc"

import { POSTER_WORDS } from "#constants"

import { CreateRandom } from "../random/CreateRandom"
import { RandomShuffle } from "../random/RandomShuffle"

// The `index`th poster word of a seed: the words shuffled once by the seed and
// taken in order, so posters in a row never repeat one until all have shown
export const PosterWord = (seed: StringGUID, index: number) => {
  const words = RandomShuffle(CreateRandom(seed, "poster words"), POSTER_WORDS)
  return words[((index % words.length) + words.length) % words.length]!
}
